import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStoreService {
  private ls = window.localStorage;
  private ss = window.sessionStorage;
  constructor() {}

  // Local storage helpers
  public setItem(key: string, value: any) {
    const str = JSON.stringify(value);
    this.ls.setItem(key, str);
    return true;
  }

  public getItem<T = any>(key: string): T | null {
    const value = this.ls.getItem(key);
    try {
      return JSON.parse(value || '');
    } catch (e) {
      return null;
    }
  }

  public removeItem(key: string) {
    this.ls.removeItem(key);
  }

  public clear() {
    this.ls.clear();
  }

  // Session storage helpers
  public setSessionItem(key: string, value: any) {
    const str = JSON.stringify(value);
    this.ss.setItem(key, str);
    return true;
  }

  public getSessionItem<T = any>(key: string): T | null {
    const value = this.ss.getItem(key);
    try {
      return JSON.parse(value || '');
    } catch (e) {
      return null;
    }
  }

  public removeSessionItem(key: string) {
    this.ss.removeItem(key);
  }

  public clearSession() {
    this.ss.clear();
  }
}
